import bannerConfig, { AlmeLiveChatBannerConfig } from '../AlmeLiveChatBanner/AlmeLiveChatBannerConfig';
import operatorConfig, { AlmeLiveChatOperatorResponseConfig } from "./AlmeLiveChatOperatorResponse/AlmeLiveChatOperatorResponseConfig";
import systemConfig, { AlmeLiveChatSystemResponseConfig } from './AlmeLiveChatSystemResponse/AlmeLiveChatSystemResponseConfig';
import userConfig, { AlmeLiveChatUserResponseConfig } from "./AlmeLiveChatUserResponse/AlmeLiveChatUserResponseConfig";

interface LiveChatResponseConfig extends AlmeLiveChatBannerConfig, AlmeLiveChatOperatorResponseConfig, AlmeLiveChatUserResponseConfig, AlmeLiveChatSystemResponseConfig { }

export interface AlmeLiveChatResponseConfig {
    liveChatResponse: LiveChatResponseConfig;
}

/**
 * This is the baseline live chat response config.
 * @summary
 * ! Important do not edit this config with client customizations!
 * Custom client config changes should be made in src/personas/config/appConfigMain
 * @see appConfigMain
*/
const defaultConfig: AlmeLiveChatResponseConfig = {
    liveChatResponse: {
        ...bannerConfig,
        ...operatorConfig,
        ...userConfig,
        ...systemConfig,
    },
};

export default defaultConfig;